// app/src/components/SignUpPageDesktopPro.tsx
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from "../../../contexts/AuthContext";
import SignUpPageDesktopPartPanel2 from "./SignUpPageDesktopPartPanel2";
import SignUpPageDesktopPartPanel1 from "./SignUpPageDesktopPartPanel1";
import { emitAnalytics, getTelemetryDeviceType } from '../../../services/telemetry/appInsights';

const SignUpPageDesktopPart = () => {
	const { t, i18n } = useTranslation();
	const {
		userInfo,
		loadUserInfoFromLocalStorage,
	} = useAuthContext();

	// 👉 Panel 1 ouvert par défaut, Panel 2 fermé
	const [isPanel1Open, setIsPanel1Open] = useState(true);
	const [isPanel2Open, setIsPanel2Open] = useState(false);
	const hasTrackedPanel2Open = useRef(false);

	useEffect(() => {
		if (!userInfo?.contact?.email) {
			loadUserInfoFromLocalStorage('');
		}
	}, []);

	useEffect(() => {
		if (isPanel2Open && !hasTrackedPanel2Open.current) {
			hasTrackedPanel2Open.current = true;
			emitAnalytics('part_signup_panel2_opened', {
				entryRoute: '/part/signup',
				deviceType: getTelemetryDeviceType(),
				language: i18n.language,
			});
		}

		if (!isPanel2Open) {
			hasTrackedPanel2Open.current = false;
		}
	}, [isPanel2Open]);
	
	if (!userInfo?.contact?.email) {
		return <></>;
	}
	
	return (
		<div
			style={{
				width: 1761,
				minHeight: 878,
				background: '#F6F8FB',
				borderRadius: 32,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				color: '#323E48',
				paddingBottom: 60,
				marginBottom: 20,
			}}
		>
			<div
				style={{
					marginTop: 57,
					height: 80,
					padding: '0 50px',
					color: '#0B5577',
					letterSpacing: 0,
					fontSize: 50,
					fontWeight: '400',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<div style={{ marginTop: '-5px' }}>
					{t('signUpPagePart:title')}
				</div>
			</div>
			<div
				style={{
					marginTop: 3,
					height: 30,
					fontSize: 31,
					fontWeight: '400',
					color: '#61AFA1',
				}}
			>
				{t('signUpPagePart:subtitle')}
			</div>
			<div style={{ height: 40 }}></div>

			<SignUpPageDesktopPartPanel1
				isOpen={isPanel1Open}
				setIsOpen={setIsPanel1Open}
			/>
			<SignUpPageDesktopPartPanel2
				isOpen={isPanel2Open}
				setIsOpen={setIsPanel2Open}
			/>

		</div>
	);
};

export default SignUpPageDesktopPart;
